import { render, staticRenderFns } from "./link-btn.vue?vue&type=template&id=e02ff344&scoped=true&"
import script from "./link-btn.vue?vue&type=script&lang=js&"
export * from "./link-btn.vue?vue&type=script&lang=js&"
import style0 from "./link-btn.vue?vue&type=style&index=0&id=e02ff344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02ff344",
  null
  
)

export default component.exports